"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAttrSchema = void 0;
const zod_1 = require("zod");
exports.TextAttrSchema = zod_1.z.enum(['bold', 'italic']);
//# sourceMappingURL=TextAttr.js.map